<template>
  <div class="view-skill-speaking">
    <div class="skill-shell">
      <section class="skill-header">
        <div class="skill-heading-wrap">
          <div class="skill-kicker">Tiêu chí chấm</div>
          <h3 class="skill-title">
            {{ typeSkill.name }}
            <span v-if="evaluationStatus === 'pass'" class="text-danger">*</span>
          </h3>
        </div>
        <div class="skill-score-box">
          <span class="skill-score-box__label">Điểm</span>
          <span class="score-display">{{ skillScore }}</span>
        </div>
      </section>

      <div class="comment-card">
        <div class="comment-section">
          <div class="comment-section__header">
            <h4 class="comment-title">Nhận xét</h4>
            <span class="comment-chip">Tổng quan</span>
          </div>
          <div class="mt-2">
            <div v-if="overallCommentType === 'file'" class="d-flex align-items-center">
              <audio controls class="audio-player">
                <source :src="overallCommentContent" type="audio/wav">
                <source :src="overallCommentContent" type="audio/mpeg">
                Trình duyệt không hỗ trợ phát audio.
              </audio>
            </div>
            <div v-else>
              <p v-if="overallCommentContent" class="comment-text">{{ overallCommentContent }}</p>
              <p v-else class="comment-empty">Không có nhận xét chung</p>
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="comment-section">
          <div class="comment-section__header">
            <h4 class="comment-subtitle">Nhận xét chi tiết</h4>
            <span class="comment-chip comment-chip--accent">Chi tiết</span>
          </div>
          <div class="mt-2">
            <div v-if="detailedCommentType === 'file'" class="d-flex align-items-center">
              <audio controls class="audio-player">
                <source :src="detailedCommentContent" type="audio/wav">
                <source :src="detailedCommentContent" type="audio/mpeg">
                Trình duyệt không hỗ trợ phát audio.
              </audio>
            </div>
            <div v-else>
              <p v-if="detailedCommentContent" class="comment-text">{{ detailedCommentContent }}</p>
              <p v-else class="comment-empty">Không có nhận xét chi tiết</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewSkillOfSpeaking',
  props: {
    currentHomework: {
      type: Object,
      default: function () {
        return {}
      }
    },
    typeSkill: {
      type: Object,
      default: function () {
        return {}
      }
    },
    evaluationStatus: {
      type: String,
      default: 'pass'
    }
  },
  computed: {
    skillData() {
      return this.currentHomework[this.typeSkill.key] || {}
    },
    skillScore() {
      const score = this.skillData.score
      return score === null || score === undefined ? 0 : score
    },
    overallComment() {
      return this.skillData.commentOverall || {}
    },
    detailedComment() {
      return this.skillData.detailedComment || {}
    },
    overallCommentType() {
      return this.overallComment.type || 'text'
    },
    detailedCommentType() {
      return this.detailedComment.type || 'text'
    },
    overallCommentContent() {
      return this.overallComment.content || ''
    },
    detailedCommentContent() {
      return this.detailedComment.content || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.view-skill-speaking + .view-skill-speaking {
  margin-top: 2rem;
}

.skill-shell {
  padding: 20px 22px;
  border: 1px solid #dbe3f2;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  box-shadow: 0 12px 28px rgba(34, 62, 110, 0.08);
}

.skill-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.skill-heading-wrap {
  min-width: 0;
}

.skill-kicker {
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
}

.skill-title {
  margin-bottom: 0;
  font-size: 1.45rem;
  color: #18264d;
}

.skill-score-box {
  min-width: 88px;
  padding: 10px 14px;
  border-radius: 16px;
  background: linear-gradient(135deg, #edf3ff 0%, #f7faff 100%);
  border: 1px solid #d6e1fb;
  text-align: center;
}

.skill-score-box__label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #6f7ea2;
}

.score-display {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  color: #2450b8;
}

.comment-card {
  padding: 1.35rem 1.5rem;
  border: 1px solid #e1e7f2;
  border-radius: 1rem;
  background: #fff;
}

.comment-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.comment-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f2f5fb;
  font-size: 12px;
  font-weight: 700;
  color: #73809d;
}

.comment-chip--accent {
  background: #ebf2ff;
  color: #2450b8;
}

.comment-title,
.comment-subtitle {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1c2d57;
}

.comment-text {
  margin-bottom: 0;
  font-size: 0.98rem;
  line-height: 1.7;
  color: #243250;
  white-space: pre-wrap;
  word-break: break-word;
}

.comment-empty {
  margin-bottom: 0;
  font-size: 0.92rem;
  font-style: italic;
  color: #8b95ab;
}

.divider {
  height: 1px;
  margin: 1.25rem 0;
  background: #e6ebf3;
}

.audio-player {
  width: 20rem;
  max-width: 100%;
  height: 2rem;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  border-radius: 0 !important;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  transform: none !important;
  transition: none !important;
  -webkit-transform: none !important;
  -moz-transform: none !important;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
}

.audio-player:hover,
.audio-player:focus,
.audio-player:active {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  transform: none !important;
  -webkit-transform: none !important;
  -moz-transform: none !important;
  outline: none !important;
}

@media (max-width: 767.98px) {
  .skill-shell {
    padding: 18px;
  }

  .skill-header {
    flex-direction: column;
  }

  .skill-score-box {
    min-width: 0;
    width: 100%;
  }
}
</style>
